<template>
  <div class="echo-test test">
    <h3>Echo Test</h3>
    <h3>Status: {{ status }}</h3>
    <h3>Timestamp: {{ timestamp }}</h3>
    <input type="button" value="Test Again" @click="test()" />
    <input type="button" value="View Raw Data" @click="dataOpen = true" />
    <div v-if="dataOpen" class="data-view">
      <a class="data-exit" href="" @click.prevent="dataOpen = false">Exit</a>
      <code>{{ JSON.stringify(response, null, 2) }}</code>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'

  export default {
    data: function () {
      return {
        response: {},
        dataOpen: false
      }
    },
    computed: {
      status: function () {
        if (!this.response.data) return 'Waiting...'
        return this.response.data.statusMessage
      },
      timestamp: function () {
        if (!this.response.data) return ''
        return this.response.data.replyTimeStamp
      }
    },
    props: {
      endpoint: String
    },
    methods: {
      test: function () {
        var data = {
          statusMessage: 'Werking!'
        }
        axios.post(this.endpoint, data).then((result) => {
          this.response = result
        })
      }
    },
    mounted: function () {
      this.test()
    }
  }
</script>
<style lang="less">
  .echo-test {
    padding: 2em;
    h3 {
      margin-top: 0;
    }
  }

  @data-margin: 32px;

  .data-exit {
    display: block;
    width: 100%;
    text-align: right;
  }

  .data-view {
    padding: 1em;
    position: fixed;
    top: @data-margin + 2px;
    bottom: @data-margin + 2px;
    right: @data-margin + 2px;
    left: @data-margin + 2px;
    z-index: 1;
    border: 1px solid green;
  }

  .data-view:before {
    content: " ";
    position: fixed;
    background-color: black;
    z-index: -1;
    top: @data-margin;
    bottom: @data-margin;
    right: @data-margin;
    left: @data-margin;

    border: 1px solid green;
  }

</style>



// WEBPACK FOOTER //
// src/components/EchoTest.vue